module.exports = __webpack_public_path__ + "static/media/2.9fe3de82.jpg";